import { keepHonorifics } from '../data/islam';
import { panel } from '../state';
import { Icon } from './icons';
import { Quote } from './Quote';

/** A short Islamic reminder (tanbīh) on a card, with the way to the fuller page and its evidence. A text it quotes is
 *  given by its id in braces ("{Q-08}") and shown as Quote shows it: word for word as approved, a verse with its Arabic. */
export function Reminder({ text }: { text: string }) {
  const parts = text.split(/\s*\{([A-Z]+-[\w:]+)\}\s*/);
  return (
    <aside class={parts.length > 1 ? 'reminder islam-note' : 'reminder'} aria-label="A reminder">
      <div class="reminder-head"><Icon name="info" size={15} /> A reminder</div>
      {parts.map((p, i) => (i % 2 ? <Quote key={i} id={p} /> : p && <p key={i}>{keepHonorifics(p)}</p>))}
      <button class="reminder-more" onClick={() => (panel.value = 'islam')}>The stars in Islam <Icon name="chevron" size={13} /></button>
    </aside>
  );
}
